import { apiFetch } from '@/shared/api/client'
import { isMockApi } from '@/shared/env'

/** Satu baris material pada dispatch gudang→dapur (mirror kitchen-server WarehouseDispatchLineItem). */
export type ApiWarehouseDispatchLine = {
  id: string
  material_id: string
  material_name: string
  uom: string
  qty_planned: number
  qty_good?: number
  qty_damaged?: number
  qty_shortage?: number
}

/** Satu dispatch gudang→dapur (mirror kitchen-server WarehouseDispatchItem). */
export type ApiWarehouseDispatch = {
  id: string
  code: string
  warehouse_name: string
  delman_name: string
  status: string
  receivable: boolean
  updated_at: string
  dispatched_at?: string
  lines: ApiWarehouseDispatchLine[]
}

export type TodayWarehouseDispatchesResponse = {
  incoming: ApiWarehouseDispatch[]
}

export type ScanWarehouseDispatchResponse = {
  dispatch_id: string
  dispatch_code: string
  warehouse_name: string
  delman_name: string
  lines: ApiWarehouseDispatchLine[]
}

/** Baris qty terima dikirim ke POST .../receive — dicocokkan server via material_id/code. */
export type WarehouseDispatchReceiveLineInput = {
  materialId?: string
  materialCode?: string
  qtyGood: number
  qtyDamaged: number
  qtyShortage: number
}

export type WarehouseDispatchActionResponse = {
  updated_at: string
}

const MOCK_INCOMING: ApiWarehouseDispatch[] = [
  {
    id: 'mock-wd-1',
    code: 'WDH-MOCK-01',
    warehouse_name: 'Gudang Pusat',
    delman_name: 'Pak Joko',
    status: 'in_transit',
    receivable: false,
    updated_at: new Date().toISOString(),
    lines: [
      { id: 'l1', material_id: 'm-tepung', material_name: 'Tepung Cakra Kembar', uom: 'kg', qty_planned: 25 },
      { id: 'l2', material_id: 'm-gula', material_name: 'Gula pasir', uom: 'kg', qty_planned: 10 },
    ],
  },
]

export async function fetchTodayWarehouseDispatches(
  _deviceId: string,
): Promise<TodayWarehouseDispatchesResponse> {
  if (isMockApi) {
    return { incoming: MOCK_INCOMING }
  }
  return apiFetch<TodayWarehouseDispatchesResponse>('/kitchen/warehouse-dispatches/today')
}

export async function scanWarehouseDispatchQr(token: string): Promise<ScanWarehouseDispatchResponse> {
  if (isMockApi) {
    await new Promise((r) => setTimeout(r, 300))
    return {
      dispatch_id: 'mock-wd-1',
      dispatch_code: 'WDH-MOCK-01',
      warehouse_name: 'Gudang Pusat',
      delman_name: 'Pak Joko',
      lines: MOCK_INCOMING[0].lines,
    }
  }
  return apiFetch('/kitchen/warehouse-dispatches/scan', {
    method: 'POST',
    body: JSON.stringify({ token }),
  })
}

export async function receiveWarehouseDispatch(
  dispatchRef: string,
  pin: string,
  lines: WarehouseDispatchReceiveLineInput[],
): Promise<WarehouseDispatchActionResponse> {
  if (isMockApi) {
    await new Promise((r) => setTimeout(r, 400))
    return { updated_at: new Date().toISOString() }
  }
  return apiFetch(`/kitchen/warehouse-dispatches/${encodeURIComponent(dispatchRef)}/receive`, {
    method: 'POST',
    body: JSON.stringify({
      pin,
      lines: lines.map((l) => ({
        material_id: l.materialId ?? '',
        material_code: l.materialCode ?? '',
        qty_good: l.qtyGood,
        qty_damaged: l.qtyDamaged,
        qty_shortage: l.qtyShortage,
      })),
    }),
  })
}
